import { requestApi } from "./axiosHelper"

const rootUrl = process.env.NODE_ENV
  ? process.env.REACT_APP_API_ROOT_URL
  : "http://localhost:8000/api/v1"

const reviewEP = rootUrl + "/review"

const reviewAPI = {
  fetchReviews: async () => {
    try {
      const axiosData = {
        url: reviewEP,
        method: "get",
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },
  updateReview: async (_id, obj) => {
    try {
      const axiosData = {
        url: `${reviewEP}/${_id}`,
        method: "put",
        data: obj,
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  deleteAReview: async (_id) => {
    try {
      const axiosData = {
        url: `${reviewEP}/${_id}`,
        method: "delete",
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  //   updateEnrol: async (_id, obj) => {
  //     console.log(obj)
  //     const axiosData = {
  //       url: `${enrolEP}/${_id}`,
  //       method: "put",
  //       data: obj,
  //     }
  //     try {
  //       const data = await requestApi(axiosData, true)
  //       return data
  //     } catch (error) {
  //       return error.response?.data || { status: "error", message: error.message }
  //     }
  //   },
}

export default reviewAPI
